interface Resettable {
  reset(): void;
}

export function resetAllStores(stores: Resettable[]): void {
  stores.forEach(store => store.reset());
}
